/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {
  getLossReasonList,
  createLossReason,
  updateLossReason,
  removeLossReason
} from "@/api/LossReason"

export default {
  addLossReason({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      
      createLossReason(payload)
        .then((response) => {
          if (response.status === 200) {
            commit('ADD_LOSS_REASON', response.data);
            resolve(response);
          } else {
            reject(new Error("Ekleme Başarısız ! " + response.status));
          }

        })
        .catch(error => {
          reject(new Error("Sunucu Bağlantısı Başarısız !"));
        })
    })
  },
  fetchDataListItemsLossReason({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      getLossReasonList(payload)
        .then((response) => {
          if (response.status === 200) {
            commit('SET_LOSS_REASONS', response.data);
            resolve(response);
          } else {
            reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
          }

        })
        .catch(error => {
          
          reject(new Error("Sunucu Bağlantısı Başarısız !"));
        })
    })
  },
  updateLossReason({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      
      updateLossReason(payload)
        .then((response) => {
          if (response.status === 200) {
            commit('UPDATE_LOSS_REASON', response.data);
            resolve(response);
          } else {
            reject(new Error("Güncelleme İşlemi Başarısız ! " + response.status));
          }

        })
        .catch(error => {
          
          reject(new Error("Sunucu Bağlantısı Başarısız !"));
        })
    })
  },
  removeLossReason({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      removeLossReason(payload)
        .then((response) => {
          if (response.status === 200) {
            commit('REMOVE_LOSS_REASON', payload);
            resolve(response);
          } else {
            reject(new Error("Silme İşlemi Başarısız ! " + response.status));
          }

        })
        .catch(error => {
          
          reject(new Error("Sunucu Bağlantısı Başarısız !"));
        })
    })
  },
};
